import api from './config'

export function getCount(
  employer_id,
) {
  return api.post('trade/getCount', {
    employer_id,
  });
}